// removed by extract-text-webpack-plugin
module.exports = {"absolute":"type__absolute___3D3rm position-absolute","relative":"type__relative___WuFPs position-relative","fixed":"type__fixed___2Ix7P position-fixed"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-position/Position/style/type.css
// module id = 37
// module chunks = 0 1 23